<div
  class="app-footer-content text-center small"
  [class.is-compact]="compact"
  [class.is-public]="publicMode"
>
  <p class="app-footer-contact mb-2" *ngIf="!compact">
    <strong>Contact us</strong> anytime on <a href="tel:1300872248">1300 872 248</a> or
    <a href="mailto:support@tracit.com.au">support&#64;tracit.com.au</a>.
  </p>

  <p class="app-footer-legal mb-0">
    &copy; <strong>TRACit</strong> {{ currentYear }}. All rights reserved.
    &nbsp;
    &middot;
    &nbsp;
    <a routerLink="/terms" target="_blank">Terms and Conditions</a>
    &nbsp;
    &middot;
    &nbsp;
    <a routerLink="/privacy" target="_blank">Privacy Policy</a>
  </p>
</div>
